module.exports = __webpack_public_path__ + "static/media/welcome-giulianocast.ac6f6508.mp3";